define('home/views/TopicTagView',[
    'backbone-marionette',
    'handlebars',
], function (
    Marionette,
    Handlebars
) {
    'use strict';

    var TopicTagView = Marionette.ItemView.extend({
        template: Handlebars.partials.topicTag,
        className: function () {
            return 'tag__item' + (this.model.get('hidden') ? ' hidden-topic' : '');
        },

        events: {
            'click [data-action=remove-tag]': 'removeTag',
        },

        initialize: function (options) {
            // Depending on where the user comes from the topic route
            // might be a global or channel-specific context. This view
            // doesn't need to know what the base is, it just needs to
            // append the topic id.
            this.topicRoute = options && options.baseTopicRoute ?
                options.baseTopicRoute + this.model.id + '/' : null;
        },

        templateHelpers: function () {
            return {
                topicRoute: this.topicRoute,
            };
        },

        removeTag: function (evt) {
            if (evt)
                evt.preventDefault();

            this.trigger('removeTag');
        },
    });

    return TopicTagView;
});

